export default __webpack_public_path__ + "static/media/pexels-photo-6097702-1.57c67d7e.png";